import EventIcon from "@mui/icons-material/Event";
import {AccountBox} from "@mui/icons-material";
export const menuLinks = [
    { title: "Users", link: "/users", icon: AccountBox },
    { title: "Posts", link: "/posts", icon: EventIcon },
];
